export default __webpack_public_path__ + "static/media/DaMitigation_FINAL_12May.8a19fa06.png";